import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';

@Component({
  selector: 'star-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit {
  constructor(private pageTitleService: PageTitleService) {}

  ngOnInit(): void {
    this.pageTitleService.setPageTitle('not-found');
  }
}
